/**
 * `useAppAuth` — the app-wide auth hook.
 *
 * Backed by server-side sessions (`lib/session.tsx`): the API owns the
 * WorkOS round-trip and the session lives in an HttpOnly cookie. The hook
 * exposes the session surface (`user`, `isLoading`, `signIn`, `signOut`,
 * `organizationId`) so call sites are provider-agnostic.
 */

import { useContext } from "react";

import { useSession } from "../lib/session";

type SessionAuth = {
  user: ReturnType<typeof useSession>["user"];
  isLoading: boolean;
  organizationId: ReturnType<typeof useSession>["organizationId"];
  signIn: () => void;
  signOut: () => void;
};

export function useAppAuth(): SessionAuth {
  const session = useSession();
  return {
    user: session.user,
    isLoading: session.isLoading,
    organizationId: session.organizationId,
    signIn: session.signIn,
    signOut: session.signOut,
  };
}